import { Component, OnDestroy, OnInit } from '@angular/core';
import { Order } from '@cemex-core/cmx-api';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { OneClickSelectOrderAction } from '../../actions/one-click-orders.actions';
import { State } from '../../reducers';
import { getOneClickOrders, getOneClickResult } from '../../selectors/one-click-orders.selector';
import { isJobsite, isPointOfDelivery } from '../../helpers';

@Component({
  selector: 'app-one-click-multiple-selection',
  templateUrl: './one-click-multiple-selection.component.html',
  styleUrls: ['./one-click-multiple-selection.component.scss'],
})
export class OneClickMultipleSelectionComponent implements OnInit, OnDestroy {
  public order: Order;
  public orderOptions: Observable<Order[]>;
  public viewOptions = {
    jobsite: {
      enabled: true,
    },
    pointOfDelivery: {
      enabled: true,
    },
  };
  public result: Observable<any>;
  private ngDestroy = new Subject();
  constructor(private store: Store<State>) {}

  ngOnInit() {
    this.orderOptions = this.store.select(getOneClickOrders).pipe(take(1));
    this.result = this.store.select(getOneClickResult);
  }

  public isJobsiteOption(order: Order): boolean {
    return isJobsite(order);
  }

  public isPointOfDeliveryOption(order: Order): boolean {
    return isPointOfDelivery(order);
  }

  public jobsiteOrderSelected(order: Order) {
    this.selectOrder(order);
    if (order) {
      this.viewOptions.pointOfDelivery.enabled = false;
    } else {
      this.viewOptions.pointOfDelivery.enabled = true;
    }
  }

  public pointOfDeliveryOrderSelected(order: Order) {
    this.selectOrder(order);
    if (order) {
      this.viewOptions.jobsite.enabled = false;
    } else {
      this.viewOptions.jobsite.enabled = true;
    }
  }

  private selectOrder(order: Order) {
    this.store.dispatch(new OneClickSelectOrderAction(order));
  }

  public ngOnDestroy(): void {
    this.ngDestroy.next();
    this.ngDestroy.complete();
  }

  public reset() {
    this.order = undefined;
    this.jobsiteOrderSelected(this.order);
    this.pointOfDeliveryOrderSelected(this.order);
  }
}
